import AdvancedSearch from '@nile/components/src/Components/AdvancedSearch/AdvancedSearch';
import {
  onAssetViewAttributeSelect,
  onAssetViewAttributeValueSearch
} from '@nile/rmm/src/modules/asset-management/services/asset-view-advanced-filter-helper';
import React from 'react';

const AssetViewRuleBuilder = (props) => {
  const { currentModule } = props;
  return (
    <AdvancedSearch
      {...props}
      onAttributeSelect={onAssetViewAttributeSelect}
      onValueSearch={onAssetViewAttributeValueSearch}
      isNewBuilder
      currentModule={currentModule?.entity || 'asset'}
    />
  );
};

export default AssetViewRuleBuilder;
